import React from 'react';
import { Accordion, Col, Form, Row } from 'react-bootstrap';

import { useFormikContext } from 'formik';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { Page500 } from '@containers/ErrorPages/Page500';
import { capacityApi } from '@reducers/capacity/capacity';

export const Trunk = () => {
  const { values, handleChange, handleBlur } = useFormikContext();
  const {
    data: result,
    isLoading,
    status,
  } = capacityApi.useGetUserTrunksForSelectQuery();

  const isRejected = status === 'rejected';
  if (isLoading) {
    return (
      <>
        <Accordion.Header>Assign Trunk</Accordion.Header>
        <Accordion.Body>
          <DefaultSpinnerCenter />
        </Accordion.Body>
      </>
    );
  }
  if (isRejected) {
    return <Page500 />;
  }
  return (
    <>
      <Accordion.Header>Assign Trunk</Accordion.Header>
      <Accordion.Body>
        <Form.Group
          as={Row}
          className="mb-1"
          controlId="form.ControlCustomerTrunk"
        >
          <Form.Label column sm="4">
            Trunk
          </Form.Label>
          <Col sm="5">
            <Form.Select
              name="customerTrunk"
              size="sm"
              value={values.customerTrunk}
              onChange={handleChange}
              onBlur={handleBlur}
            >
              {result.map(({ value: id, name }) => (
                <option value={id} key={id}>
                  {name}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Form.Group>
      </Accordion.Body>
    </>
  );
};
